import React from 'react';
import { Video, Camera, TrendingUp, Sparkles, Users, Globe, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { servicesData } from '../data/mockData';

const iconMap = {
  Video: Video,
  Camera: Camera,
  TrendingUp: TrendingUp,
  Sparkles: Sparkles,
  Users: Users,
  Globe: Globe,
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon];
  const hasLink = service.link;
  
  const CardContent = () => (
    <>
      <div className="mb-6">
        {IconComponent && (
          <IconComponent 
            size={32} 
            className="text-[#c9a962] group-hover:scale-110 transition-transform duration-300" 
            strokeWidth={1.5}
          />
        )}
      </div>
      
      <h3 className="heading-3 text-white mb-1">
        {service.title}
      </h3>
      
      <span className="body-small text-[#c9a962] block mb-4">
        {service.subtitle}
      </span>
      
      <p className="body-regular text-[#b3b3b3]">
        {service.description}
      </p>
      
      {hasLink && (
        <span className="inline-flex items-center gap-2 mt-4 text-sm font-medium text-[#c9a962] group-hover:gap-3 transition-all">
          View Packages
          <ArrowRight size={16} />
        </span>
      )}
    </>
  );
  
  if (hasLink) {
    return (
      <a 
        href={service.link}
        className="group block p-8 bg-[#141414] border border-[#2a2a2a] hover:border-[#c9a962]/50 transition-all duration-300 cursor-pointer"
      >
        <CardContent />
      </a>
    );
  }
  
  return (
    <div className="group p-8 bg-[#141414] border border-[#2a2a2a] hover:border-[#c9a962]/50 transition-all duration-300">
      <CardContent />
    </div>
  );
};

const Services = () => {
  return (
    <section id="services" className="section-padding bg-[#111111]">
      <div className="container">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <span className="inline-block text-sm font-medium text-[#c9a962] tracking-wider uppercase mb-4">
            How I Can Help
          </span>
          
          <h2 className="heading-1 text-white mb-6">
            Services That Drive Results
          </h2>
          
          <p className="body-large text-[#b3b3b3]">
            Every service is designed to help your business get discovered, build trust, and turn social media followers into paying customers.
          </p>
        </div>
        
        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {servicesData.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center">
          <p className="body-regular text-[#808080] mb-4">
            Not sure which service you need?
          </p>
          <Button 
            asChild
            className="bg-transparent text-[#c9a962] border border-[#c9a962] hover:bg-[#c9a962] hover:text-[#0a0a0a] rounded-none px-8 py-4 h-auto text-sm font-medium transition-all duration-300"
          >
            <a href="#contact" className="inline-flex items-center gap-2">
              Let's Chat About Your Goals
              <ArrowRight size={16} />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
